import type {SearchFormPageData} from './types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export class SearchFormDataService {
    public static serviceName = 'searchFormDataService';

    private static readonly SEARCH_FORM_ROUTE = 'search-form';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getPageData(): Promise<SearchFormPageData> {
        return this.ajaxService
            .createRequest(SearchFormDataService.SEARCH_FORM_ROUTE)
            .get();
    }
}